import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Compassion Course Foundation</h4>
            <p>Peace Education for Everyone, Everywhere, All at Once.</p>
          </div>
          
          <div className="footer-section">
            <h5>Quick Links</h5>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/programs">Programs</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/board">Board Members</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h5>Get Involved</h5>
            <ul>
              <li><Link to="/donate">Donate</Link></li>
              <li><a href="#newsletter">Newsletter</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h5>Connect</h5>
            <div className="social-links">
              <a href="#" aria-label="Facebook">Facebook</a>
              <a href="#" aria-label="Twitter">Twitter</a>
              <a href="#" aria-label="Instagram">Instagram</a>
              <a href="#" aria-label="LinkedIn">LinkedIn</a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Compassion Course Foundation, Inc. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
